"use client"

import type { ReactNode } from "react"
import { Analytics, AnalyticsConfig } from "pliny/analytics"
import { useState } from "react"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import MobileMenu from "@/components/MobileMenu"
import siteMetadata from "@/data/siteMetadata"
import { ThemeProviders } from "./theme-providers"

export default function AppShell({ children }: { children: ReactNode }) {
	const [openClass, setOpenClass] = useState("")

	const handleOpen = () => {
		document.body.classList.add("mobile-menu-active")
		setOpenClass("sidebar-visible")
	}

	const handleRemove = () => {
		if (openClass === "sidebar-visible") {
			document.body.classList.remove("mobile-menu-active")
			setOpenClass("")
		}
	}

	return (
		<ThemeProviders>
			<Analytics analyticsConfig={siteMetadata.analytics as AnalyticsConfig} />

			{openClass && (
				<div className="body-overlay-1" onClick={handleRemove} role="presentation" />
			)}
			<Header handleOpen={handleOpen} handleRemove={handleRemove} openClass={openClass} />
			<MobileMenu openClass={openClass} handleRemove={handleRemove} />
			<main className="main shadow-container">
				<div className="ma">{children}</div>
				<Footer />
			</main>
		</ThemeProviders>
	)
}
